import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/siteData";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-heart-pulse-line text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950">{siteConfig.siteName}</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              高清视频在线观看，情感交流社区。专注恋爱技巧、情感故事、婚姻经营、心理学知识分享。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">网站首页</Link></li>
              <li><Link to="/category/dating-tips" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">恋爱技巧</Link></li>
              <li><Link to="/category/love-stories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">情感故事</Link></li>
              <li><Link to="/category/marriage" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">婚姻经营</Link></li>
              <li><Link to="/category/psychology" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">心理学堂</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门推荐</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/category/relationships" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">两性话题</Link></li>
              <li><Link to="/category/hot-shows" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热门综艺</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-base text-foreground-500"></i>
                {siteConfig.contactEmail}
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line text-base text-foreground-500"></i>
                {siteConfig.contactPhone}
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-base text-foreground-500 mt-0.5"></i>
                <span>{siteConfig.address}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-time-line text-base text-foreground-500"></i>
                周一至周日 9:00-21:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteConfig.siteName} 版权所有 | 本站内容仅供学习交流
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}